import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { Th, THead, TableHeaderRow, FlexCenterWrapper, Mr2 } from 'wrappers';
import { TableHeaderElement } from 'molecules';
import internalState from './internalState';
import { ClickableIcon } from 'atoms';
import { CheckboxSvg } from 'components/icons';

export const definition = {
  name: 'Header',
  controller: Controller,
  initialProps: ({ orderBy, orderDirection, headers, isSelected, hasCheckbox }) => ({ orderBy, orderDirection, headers, isSelected, hasCheckbox }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(TableHeaderRow, THead),
      name: 'Header',
      renderIf: ({ headers }) => headers.length > 0,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, Th),
          name: 'NameHeader',
          elements: [
            {
              component: wrap(ClickableIcon, Mr2),
              renderIf: ({ hasCheckbox }) => hasCheckbox,
              name: 'HeaderCheckbox',
              bindings: ({ }) => ({}),
              displayValue: ({ isSelected }) => CheckboxSvg({ checked: isSelected })
            },
            {
              component: TableHeaderElement,
              name: 'TableHeader',
              bindings: ({ orderBy, orderDirection, headers }) => ({ orderDirection, orderBy, content: headers[0], sortOrder: orderBy === headers[0].sortingField ? orderDirection : '' })
            }
          ]
        },
        {
          component: wrap(TableHeaderElement, Th),
          name: 'TableHeader',
          isListOf: { header: ({ headers }) => headers.slice(1) },
          bindings: ({ header, orderDirection, orderBy }) => ({ orderDirection, orderBy, content: header, sortOrder: orderBy === header.sortingField ? orderDirection : '' })
        }
      ]
    },
  ]
}

export default ContainerComponent(definition);